import React, { useEffect, useState } from 'react'
import { Container, Grid } from '@material-ui/core'
import { ChatbotConfigurationKnowledgeView } from '../../views'
import { ChatbotService } from '../../../services';
import { ModalUtil, SimpleLoading, HeaderHLPure } from '../../pures';
import { useTranslation } from 'react-i18next';
import { useGlobalState } from '../../../GlobalState';

const ChatbotConfigurationKnowledgeAction = (props) => {
    const { setLoading, files, setFiles } = props
    const { t } = useTranslation()
    
    const modalUtil = new ModalUtil()

    const url = process.env.REACT_APP_ETICKET_API
    const chatbotService = new ChatbotService(url)

    const [filesToUpload, setFilesToUpload] = useState([])
    const [fileToDelete, setFileToDelete] = useState(false);
    const { botConfig } = useGlobalState()
    
    const uploadFiles = async (filesToUpload) => {
        try {
            modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))
            const formData = new FormData();
            filesToUpload.forEach((file) => {
                formData.append('knowledgeFiles', file.getRawFile());
            });

            const data = await chatbotService.uploadKnowledgeFiles(formData, botConfig?.id)
            if (filesToUpload.length > 1) {
                setFiles(prev => [...prev, ...data])
            } else {
                setFiles(prev => [...prev, data])
            }
            setFilesToUpload([])

            modalUtil.showModal('success', null, t("modal.pure.title.success"))
        } catch (error) {
            modalUtil.showModal('error', error.message, t("modal.pure.title.error"))
        }
    }

    const deleteFile = async () => {
        try {
            modalUtil.showModal('loading', t("modal.pure.loading.message"), t("modal.pure.loading.title"))
            const id = fileToDelete.id
            setFileToDelete(null)
            await chatbotService.deleteKnowledgeFile(id, botConfig?.id)
            setFiles(prev => prev.filter(file => file.id !== id))
            modalUtil.showModal('success', null, t("modal.pure.title.success"))
        } catch (error) {
            modalUtil.showModal('error', error.message, t("modal.pure.title.error"))
        }
        setLoading(false)
    }

    return (
        <ChatbotConfigurationKnowledgeView
            files={files}
            uploadFiles={uploadFiles}
            filesToUpload={filesToUpload}
            setFilesToUpload={setFilesToUpload}
            deleteFile={deleteFile}
            fileToDelete={fileToDelete}
            setFileToDelete={setFileToDelete}
        />
    )
}

export default ChatbotConfigurationKnowledgeAction